import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1a33d98"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "colorbar-labels" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "colorbar-container"
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle({'--background-color': _ctx.backgroundColor}),
      class: "colorbar"
    }, null, 4),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1)
  ], 8, _hoisted_1))
}